<template>
  <div>
    <template v-for="item in detailInfo">
      <DetailInfo :key="item.id" :formLayout="changeDetailInfo(item)" :columnNum="2" />
      <a-divider />
    </template>
  </div>
</template>

<script>
import { medicalRecordList } from '@api/online'
import { prescriptionInfo } from '@views/onlineModal/formItemConfig'
import DetailInfo from '@comp/DetailInfo/DetailInfo'

export default {
  name: 'prescriptionInfo',
  title: '处方详情',
  components: { DetailInfo },
  data() {
    return {
      formLayout: [],
      detailInfo: []
    }
  },
  props: {
    detailData: {
      type: Object
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let params = {
        diagnosticId: this.detailData.id,
        pageNo: 1,
        pageSize: 100000
      }
      medicalRecordList(params).then(res => {
        this.detailInfo = res.result.records
      })
    },
    // 转换详情数据
    changeDetailInfo(data) {
      if (!data) return
      let arr = []
      prescriptionInfo.forEach(ele => {
        arr.push({
          ...ele,
          value: data[ ele.field ]
        })
      })
      return arr
    }
  }
}
</script>